import React from 'react';

import PropTypes from 'prop-types';

import makeStyles from '@material-ui/core/styles/makeStyles';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';

import CheckboxButton from 'components/buttons/CheckboxButton';

const useStyles = makeStyles({
  formGroup: {
    maxWidth: '270px',
    marginLeft: '25px'
  },
  formTitle: {
    textTransform: 'uppercase',
    fontWeight: '600'
  },
  formButton: {
    marginLeft: '-12px',
    marginTop: '16px'
  }
});

const MoreOptionsMenu = ({
  onSubmit,
  register,
  handleClose,
  isLegendDisplayed,
  isTitleDisplayed,
  isChartTooltipDisplayed,
  isDateDisplayed
}) => {
  const classes = useStyles();

  const options = [
    {
      title: 'Show widget Legend',
      value: isLegendDisplayed,
      name: 'isLegendDisplayed'
    },
    {
      title: 'Show widget title',
      value: isTitleDisplayed,
      name: 'isTitleDisplayed'
    },
    {
      title: 'Show date range under the title',
      value: isDateDisplayed,
      name: 'isDateDisplayed'
    },
    {
      title: 'Show tooltip on hover',
      value: isChartTooltipDisplayed,
      name: 'isChartTooltipDisplayed'
    }
  ];

  return (
    <form onSubmit={onSubmit} className={classes.formGroup}>
      <Typography variant="subtitle2" className={classes.formTitle} gutterBottom>
        More Options
      </Typography>
      <Grid container direction="row" justify="flex-start" alignItems="flex-start">
        {options &&
          options.map(option => (
            <Grid item xs={12} md={12} key={option.name}>
              <CheckboxButton
                title={option.title}
                checked={option.value}
                name={option.name}
                inputRef={register}
              />
            </Grid>
          ))}

        <Grid item xs={5}>
          <Button variant="contained" color="primary" type="submit" className={classes.formButton}>
            Save
          </Button>
        </Grid>
        <Grid item xs={5}>
          <Button color="primary" onClick={handleClose} className={classes.formButton}>
            Cancel
          </Button>
        </Grid>
      </Grid>
    </form>
  );
};

MoreOptionsMenu.propTypes = {
  onSubmit: PropTypes.func.isRequired,
  register: PropTypes.func.isRequired,
  handleClose: PropTypes.func.isRequired,
  isLegendDisplayed: PropTypes.bool.isRequired,
  isTitleDisplayed: PropTypes.bool.isRequired,
  isDateDisplayed: PropTypes.bool.isRequired,
  isChartTooltipDisplayed: PropTypes.bool.isRequired
};

export default MoreOptionsMenu;
